import './assets/styles/main.scss';
import 'primeicons/primeicons.css';

import { createApp } from 'vue';

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import App from './App.vue';
import router from './router';
import initSentry from './instrument';

const app = createApp(App);

app.use(PrimeVue, {
  // Default theme configuration
  theme: 'none',
});

app.use(router);
app.use(ToastService);

initSentry(app, router);

app.mount('#app');
